import React from "react"
import cx from 'classnames'
import { Link } from "gatsby"

import * as styles from './Navigation.module.css'

export function Navigation ({ expanded, onExpandedChange}) {
  return (
    <nav className={cx(styles.navigation, expanded && styles.navigationIsExpanded)} role="navigation">
      <button type="button" onClick={() => { onExpandedChange(!expanded) }} className={styles.closeButton}>
        <span className={cx('u-screenreader-text')}>Sluit menu</span>
      </button>
      <Link to="/" className={styles.link} activeClassName={styles.linkActive}>Home</Link>
      <Link to="/traject" className={styles.link} activeClassName={styles.linkActive}>Traject</Link>
      <Link to="/coach" className={styles.link} activeClassName={styles.linkActive}>Coach</Link>
      <Link to="/introductie" className={styles.link} activeClassName={styles.linkActive}>Even voorstellen</Link>
      <Link to="/contact" className={styles.link} activeClassName={styles.linkActive}>Contact</Link>
    </nav>
  )
}
